import styled from 'styled-components';
export const ContentInformation = styled.div.withConfig({
  displayName: "GeneralInformationstyle__ContentInformation",
  componentId: "sc-1wkqlfe-0"
})(["", " >div:nth-child(odd){", "}"], {
  "display": "flex",
  "flexDirection": "column"
}, {
  "backgroundColor": "rgb(235,235,235,0.24)"
});
export const Border = styled.div.withConfig({
  displayName: "GeneralInformationstyle__Border",
  componentId: "sc-1wkqlfe-1"
})(["", ""], {
  "marginTop": "1rem",
  "marginBottom": "1rem",
  "borderWidth": "0.5px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(235 235 235 / var(--tw-border-opacity, 1))"
});
export const TagList = styled.div.withConfig({
  displayName: "GeneralInformationstyle__TagList",
  componentId: "sc-1wkqlfe-2"
})(["", " @media (max-width:", "){", "}"], {
  "display": "none",
  "gap": "0.25rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.5rem"
});
export const HashTagItem = styled.div.withConfig({
  displayName: "GeneralInformationstyle__HashTagItem",
  componentId: "sc-1wkqlfe-3"
})(["", " color:#0099ff;a{", "}@media (max-width:", "){", "}"], {
  "display": "flex",
  "flexDirection": "row",
  "flexWrap": "wrap"
}, {
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "lineHeight": "1.5rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "display": "none"
});